import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import VendorMaster from './components/VendorMaster';
import ProductMaster from './components/ProductMaster';
import LocationMaster from './components/LocationMaster';
import CurrencyMaster from './components/CurrencyMaster';
import TaxMaster from './components/TaxMaster';
import CategoryMaster from './components/CategoryMaster';
import SubcategoryMaster from './components/SubcategoryMaster';
import Profile from './components/Profile';
import ClientMaster from './components/ClientMaster';
import UserMaster from './components/UserMaster';
import RFQItemsMaster from './components/RFQItemsMaster';
import PaymentTermsMaster from './components/PaymentTermMaster';
import DeliveryTermMaster from './components/DeliveryTermMaster';
import ApiMappingScreen from './components/ApiMappingScreen';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/vendor-master" element={<VendorMaster />} />
        <Route path="/product-master" element={<ProductMaster />} />
        <Route path="/location-master" element={<LocationMaster />} />
        <Route path="/currency-master" element={<CurrencyMaster />} />
        <Route path="/tax-master" element={<TaxMaster />} />
        <Route path="/delivery-term-master" element={<DeliveryTermMaster />} />
        <Route path="/category-master" element={<CategoryMaster />} />
        <Route path="/subcategory-master" element={<SubcategoryMaster />} />
        <Route path="/payment-terms-master" element={<PaymentTermsMaster />} />
        <Route path="/api-mapping-screen" element={<ApiMappingScreen />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/user-master" element={<UserMaster />} />
        <Route path="/client-master" element={<ClientMaster />} />
        <Route path="/rfq-items-master" element={<RFQItemsMaster />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;